// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorMessage_errorMessage__rgEm5","icon":"ErrorMessage_icon__ow7F1"};